import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContract = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "none",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.9993 5.00033C14.9602 3.70616 14.816 2.93366 14.281 2.39949C13.5477 1.66699 12.3677 1.66699 10.0077 1.66699H6.67185C4.31185 1.66699 3.13185 1.66699 2.39935 2.39949C1.66602 3.13116 1.66602 4.31033 1.66602 6.66699V13.3337C1.66602 15.6903 1.66602 16.8695 2.39935 17.6012C3.13268 18.3328 4.31185 18.3337 6.67185 18.3337H10.0085C12.3677 18.3337 13.5477 18.3337 14.281 17.6012C14.816 17.067 14.9602 16.2953 14.9993 15.0003",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.8677 9.785L17.8485 8.80417C18.0735 8.57917 18.1868 8.46583 18.2468 8.34417C18.3028 8.23003 18.3319 8.10461 18.3319 7.9775C18.3319 7.85039 18.3028 7.72497 18.2468 7.61083C18.1868 7.48917 18.0735 7.37583 17.8485 7.15083C17.6235 6.92583 17.5102 6.8125 17.3885 6.7525C17.2744 6.69657 17.149 6.6675 17.0218 6.6675C16.8947 6.6675 16.7693 6.69657 16.6552 6.7525C16.5335 6.8125 16.421 6.92583 16.1952 7.15083L15.2143 8.13167M16.8677 9.785L12.4793 14.1733L9.99935 15L10.826 12.52L15.2143 8.13167M16.8677 9.785L15.2143 8.13167M4.16602 15.8333H4.99935L6.04102 13.75L7.08268 15.8333H7.91602M4.99935 5H11.666M4.99935 8.33333H9.99935",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgContract;
